export default "__VITE_ASSET__GMT$i1W6__"